module.exports = __webpack_public_path__ + "media/images/wineries400x300-8730b8e710b3cdf29e085f26862d0957.png";